import {Dialog, DialogActions, DialogContent, DialogTitle,} from "@mui/material";
import {FullButton} from "../../../../components/button/common_button";
import CommonColorUtils from "../../../../utils/common_colors";
import {useEffect, useState} from "react";

export function AddToExistingConfirmDialog({
                                               isDialogOpen,
                                               handleCloseDialog,
                                               selectedOrderCount,
                                               taskType,
                                               selectedTask,
                                               handleAddToExistingConfirmButton
                                           }) {

    const [selectedOrderCountWithType, setSelectedOrderCountWithType] = useState('');

    useEffect(() => {
        if (taskType?.toLowerCase() === 'forward') {
            setSelectedOrderCountWithType(`Pickup (${selectedOrderCount.length})`);
        } else if (taskType?.toLowerCase() === 'return') {
            setSelectedOrderCountWithType(`Return (${selectedOrderCount.length})`);
        } else if (taskType?.toLowerCase() === 'rto') {
            setSelectedOrderCountWithType(`RTO (${selectedOrderCount.length})`);
        }
    }, [taskType, selectedOrderCount.length])

    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            sx={{
                "& .MuiDialog-paper": {
                    width: "500px",
                    maxHeight: "600px",
                    borderRadius: "8px"
                },
            }}
        >
            <DialogTitle>
                    <span
                        style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            fontFamily: "Inter, Arial, sans-serif",
                        }}>   {"Confirm changes?"}</span>

            </DialogTitle>
            <DialogContent>
                <div style={{marginBottom: "20px"}}>
                    <span>{`Are you sure you would like to add`}</span>
                    <span style={{fontWeight: 600}}>{` ${selectedOrderCountWithType}`}</span>
                    <span>{` to the existing task- `}</span>
                    <span style={{fontWeight: 600}}>{`${selectedTask}?`}</span>
                </div>
                <span style={{color: CommonColorUtils.primaryMainBlue, fontStyle: "italic"}}>Once created, it will move to either unassigned task or assigned task tab.</span>

            </DialogContent>
            <DialogActions>
                <div style={{display: "flex", gap: "10px", marginRight: "10px"}}>
                    <button
                        style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            width: "120px",
                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                            height: 48,
                        }}
                        onClick={handleCloseDialog}
                    >
            <span style={{fontWeight: 600, fontSize: "14px", color: "black"}}>
              Cancel
            </span>
                    </button>

                    <FullButton
                        buttonText={"Yes, confirm"}
                        activeColor={CommonColorUtils.primaryMainBlue}
                        inactiveColor={CommonColorUtils.primaryMainBlueDisabledColor}
                        buttonTextColor={CommonColorUtils.primaryKWhite}
                        active={true}
                        height={"48px"}
                        width={"180px"}
                        customCursor={"pointer"}
                        isDisable={false}
                        handleOnPress={
                            handleAddToExistingConfirmButton
                        }
                    />
                </div>
            </DialogActions>
        </Dialog>
    );
}
